export const dateFormat = "MMM 'YY";
